import React from 'react';

const defaultFormatLabel = (tag) => tag;

const TagList = ({ tags = [], t, formatLabel = defaultFormatLabel, className = '' }) => {
  if (!tags.length) return null;

  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`.trim()}>
      {tags.map((tag, index) => (
        <span key={`${tag}-${index}`} className="chip-tag-neutral">
          {formatLabel(tag, t)}
        </span>
      ))}
    </div>
  );
};

TagList.displayName = 'TagList';

export default TagList;
